import { createSelector } from '@reduxjs/toolkit';
import { selectHouseYear } from 'shared/selectors/jsonQuery';

export const selectHouseYearFilter = createSelector(selectHouseYear, range => ({
  value: { min: range?.gte ?? null, max: range?.lte ?? null },
  min: 1800,
  max: 2038,
}));
